<div class="documents-questions">

  <!-- Questions Block Title -->
  <div class="documents-questions-title">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 37 38">
      <g id="Group_210" data-name="Group 210" transform="translate(-246 -132)">
        <circle id="Ellipse_8" data-name="Ellipse 8" cx="18.5" cy="18.5" r="18.5" transform="translate(246 132)"
          fill="#ABCB0B" />
            <text id="_5" data-name="3" transform="translate(256 162)" fill="#FFF" font-size="30" font-family="Outfit" font-weight="700">
              <tspan x="0" y="0">{{ isNexusEnabled ? '4' : '3' }}</tspan>
            </text>            
      </g>
    </svg> select answers
  </div>

  <!-- Show loading screen when questions are disabled -->
  <div class="rm-spinner-wrapper" *ngIf="loadingState || noDataState">
    <div class="rm-spinner-text">{{loadingMessage}}</div>
    <div class="rm-spinner" [ngClass]="spinnerStyle"></div>
  </div>

  <!-- Hide questions block while it's disabled -->
  <div *ngIf="!loadingState">
    <form *ngIf="selectedReasons.length > 0">
      <button type="submit" style="visibility: hidden;"></button>

      <div class="label info red" *ngIf="getDocumentsError">
        an error occurred whilst getting the documents, please refresh the page to try again
      </div>

      <div class="questions-block" *ngIf="prologueQuestions.length > 0">
        <div class="block-overflow" *ngIf="questionsLoadingState"></div>
        <div class="block box-shadow">
          <div class="question-block" *ngFor="let question of prologueQuestions"
            [attr.data-id]="'question-' + question.id">
            <question [question]="question" (questionAnswered)="question.answerSelected = $event.answer;
                            questionChanged(question)"></question>
          </div>
        </div>
      </div>

      <!-- Documents -->
      <div class="documents-block" *ngIf="documentsList.length > 0">
        <div class="documents-block-overflow" *ngIf="questionsLoadingState"></div>
        <h2>documents</h2>
        <div class="block box-shadow">
          <h3>select the documents or evidence that the driver provided in their letter</h3>
          <label class="question-label checkbox" *ngFor="let document of documentsList"
            [ngClass]="{
              'selected': document.selected
            }"
            [attr.data-id]="'document-' + document.id">

            <span class="doc-text">
              <span>{{ document.caption }}</span>
              <span *ngIf="documentHasEvidence(document.caption)"
                    class="ai-badge"
                    [title]="documentConfidence(document.caption)?.confidence != null ? (documentConfidence(document.caption).confidence * 100 | number:'1.0-0') + '% confidence' : ''">
                AI{{ documentConfidence(document.caption)?.confidence != null ? ' ' + (documentConfidence(document.caption).confidence * 100 | number:'1.0-0') + '%' : '' }}
              </span>
              <span *ngIf="!documentHasEvidence(document.caption) && documentGuess(document.caption) as guess"
                    class="ai-badge ai-badge-guess"
                    [title]="'Unconfirmed AI guess' + (showDocumentConfidence && guess.confidence != null ? ' (' + (guess.confidence * 100 | number:'1.0-0') + '% confidence)' : '') + ' - please verify against the document before ticking'">
                AI{{ showDocumentConfidence && guess.confidence != null ? ' ~' + (guess.confidence * 100 | number:'1.0-0') + '%' : '' }}
              </span>
            </span>

            <input aria-label=""
                  type="checkbox"
                  [checked]="document.selected"
                  (change)="document.selected = !document.selected; onDocumentSelected(document)"
                  [aria-checked]="document.selected">
          </label>
        </div>
        <hr class="documents-questions-divider">
      </div>
      <div class="label info red" *ngIf="getQuestionsError">
        an error occurred whilst getting the questions, please refresh the page to try again
      </div>

      <!-- Questions -->
      <div class="questions-container">
        <!-- Questions by Reason -->
        <div class="questions-block" *ngIf="questionsList.length > 0">
          <div class="block-overflow" *ngIf="questionsLoadingState"></div>
          <div *ngFor="let reason of selectedReasons; trackBy: trackByReasonId">
            <div *ngIf="getQuestionsByReason(reason.id).length > 0">
              <h2>{{reason.caption}}</h2>
              <div class="block box-shadow">
                <div class="question-block" 
                *ngFor="let question of getQuestionsByReason(reason.id); trackBy: trackByQuestionId" 
                [attr.id]="'question-' + question.id"
                [attr.data-id]="'question-' + question.id">
                  <question [question]="question" 
                  (questionAnswered)="question.answerSelected = $event.answer; questionChanged(question)">
                </question>
                </div>
              </div>
              <hr class="documents-questions-divider">
            </div>
          </div>
        </div>
        <!-- Questions by Document -->
        <div class="questions-block" *ngIf="documentsList.length > 0 && !questionsLoadingState">
          <div *ngFor="let document of documentsList; trackBy: trackByDocumentId">
            <div *ngIf="document.selected && getQuestionsByDocument(document.id).length > 0">
              <h2>{{document.caption}}</h2>
              <div class="block box-shadow">
                <div class="question-block" 
                *ngFor="let question of getQuestionsByDocument(document.id);  trackBy: trackByQuestionId"
                [attr.id]="'question-' + question.id"
                  [attr.data-id]="'question-' + question.id">
                  <question [question]="question" (questionAnswered)="question.answerSelected = $event.answer;
                            questionChanged(question)"></question>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Unsorted Questions -->
        <div class="questions-block" *ngIf="getUnsortedQuestions().length > 0">
          <div class="block-overflow" *ngIf="questionsLoadingState"></div>
          <div class="block box-shadow">
            <div class="question-block" *ngFor="let question of getUnsortedQuestions();  trackBy: trackByQuestionId"
            [attr.id]="'question-' + question.id"
              [attr.data-id]="'question-' + question.id">
              <question [question]="question" (questionAnswered)="question.answerSelected = $event.answer;
                            questionChanged(question)"></question>
            </div>
          </div>
        </div>
        <!-- Clarification Questions -->
        <div class="questions-block" *ngIf="clarificationQuestions.length > 0">
          <div class="block-overflow" *ngIf="questionsLoadingState"></div>
          <div class="block box-shadow">
            <div class="question-block" *ngFor="let question of clarificationQuestions;  trackBy: trackByQuestionId"
            [attr.id]="'question-' + question.id"
              [attr.data-id]="'question-' + question.id">
              <question [question]="question" (questionAnswered)="question.answerSelected = $event.answer; questionChanged(question)"></question>
            </div>
          </div>
          <hr class="documents-questions-divider">
        </div>
      </div>

      
<!-- Additional Explanations -->
<div class="label info red" *ngIf="getAdditionalExplanationsError">
  an error occurred whilst getting the additional explanations, please refresh the page to try again
</div>
<div class="documents-block" *ngIf="additionalExplanationsMaster.length > 0" role="group"
  aria-label="additional explanations">
  <div class="documents-block-overflow" *ngIf="questionsLoadingState"></div>
  <h2>additional explanations</h2>
  <div class="block box-shadow">
    <h3>Select the additional explanations that you would like to include in the letter</h3>
    <div class="block box-shadow">
      <label class="question-label checkbox" *ngFor="let explanation of additionalExplanationsMaster; trackBy: trackByExplanationId"
        [ngClass]="{'selected': explanation.selected}" [attr.data-id]="'explanation-' + explanation.id">
        <div class="checkbox-container">
          <input aria-label="{{explanation.name}}" type="checkbox" [(ngModel)]="explanation.selected"
            (change)="onExplanationSelected(explanation)" role="checkbox">
          <div class="explanation-content">
            <h3>{{ explanation.name }}</h3>

            <span class="explanation-text" [ngClass]="{'expanded': explanation.expanded}">
              {{ explanation.letterText }}
            </span>

            <button *ngIf="explanation.letterText.length > 100" class="see-more-btn"
              (click)="toggleExplanation(explanation)">
              {{ explanation.expanded ? 'See less' : 'See more' }}
            </button>
          </div>
        </div>
      </label>
    </div>
  </div>
  <hr class="documents-questions-divider">
</div>

    </form>
  </div>
</div>